/**
 * Галочки схем импорта (архив от продавца, сессия вручную): проверка @SpamBot и
 * "был 2FA". KAN-676: проверка @SpamBot по умолчанию выключена, в API уходит
 * skip_spam_check=true, пока галочка не включена (skipSpamCheckFromFlag).
 * Значения и умолчания: ImportFlags / DEFAULT_IMPORT_FLAGS в lib/telegramConnect.
 */
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import type { ImportFlags } from '@/lib/telegramConnect';

export const SPAM_CHECK_LABEL = 'Проверять @SpamBot';
export const SPAM_CHECK_HINT =
  'Запрос к @SpamBot сразу после входа. Для свежего аккаунта лучше не включать.';
export const HAD_2FA_LABEL = 'У аккаунта был пароль 2FA';

interface Props {
  /** Префикс id и data-testid: `${idPrefix}-check-spam`, `${idPrefix}-had-2fa`. */
  idPrefix: string;
  values: ImportFlags;
  onChange: (patch: Partial<ImportFlags>) => void;
  disabled?: boolean;
}

export function ImportFlagsFields({
  idPrefix,
  values,
  onChange,
  disabled,
}: Props): JSX.Element {
  const spamId = `${idPrefix}-check-spam`;
  const twoFaId = `${idPrefix}-had-2fa`;
  return (
    <div className="space-y-3">
      <div className="space-y-1">
        <div className="flex items-center gap-2">
          <Checkbox
            id={spamId}
            data-testid={spamId}
            aria-label={SPAM_CHECK_LABEL}
            aria-describedby={`${spamId}-hint`}
            checked={values.checkSpam}
            disabled={disabled}
            onCheckedChange={(checkSpam) => onChange({ checkSpam })}
          />
          <Label htmlFor={spamId}>{SPAM_CHECK_LABEL}</Label>
        </div>
        <p id={`${spamId}-hint`} className="text-xs text-gray-500">
          {SPAM_CHECK_HINT}
        </p>
      </div>
      <div className="flex items-center gap-2">
        <Checkbox
          id={twoFaId}
          data-testid={twoFaId}
          aria-label={HAD_2FA_LABEL}
          checked={values.had2fa}
          disabled={disabled}
          onCheckedChange={(had2fa) => onChange({ had2fa })}
        />
        <Label htmlFor={twoFaId}>{HAD_2FA_LABEL}</Label>
      </div>
    </div>
  );
}
